module.exports = __webpack_public_path__ + "static/media/architecture.8c986c08.jpg";